import React, { useEffect } from "react";
import Navigation from "./NavigationBar";
import { MDBAnimation } from "mdbreact";
import CarouselPage from "./MAINcomponent/projectslider";
import Contact from "./MAINcomponent/ContactComponent";
import Team from "./MAINcomponent/teamComponent";
import Work from "./MAINcomponent/workComponent";
import { FaCode, FaVideo } from "react-icons/fa";
import { CgDesignmodo } from "react-icons/cg";
export default function Home() {
  useEffect(() => {}, []);
  return (
    <div>
      <Navigation />
      <div className="backcover" id="home">
        <div id="Main">
          <h1>
            <span>
              <FaVideo
                style={{ paddingBottom: 13 }}
                size={40}
                color={"#333555"}
              />{" "}
              Editors,{" "}
            </span>
            <span>
              <CgDesignmodo style={{ paddingBottom: 13 }} color={"#ff7"} />{" "}
              Designers, {"&"}{" "}
            </span>
            <span>
              <FaCode style={{ paddingBottom: 13 }} size={35} color={"white"} />{" "}
              Developers
            </span>
          </h1>
          <p>
            We are a team of Developers, Designers and Editors. We work on
            Website Design and Development, Mobile Application ( Android and IOS
            ) Design and Development and Video Editing. We can develop any
            websites with a custom, Responsive and Mobile Friendly Design.
            Similarly we can develop any types of Android or IOS apps with
            completely unique and custom design. For the back-end part, we can
            develop a fully functional, Fast and Secure API with all the
            required features and functionalities according to the project. Any
            type of Video editing can be done.
          </p>
        </div>
      </div>
      <div className="main_section">
        <div className="row">
          <div className="col work_section">
            <div id="work">
              <MDBAnimation reveal type="zoomIn" duration="1000ms" delay="0.4s">
                <h1 className="animated fadeInUp"> Work </h1>
              </MDBAnimation>
              <Work />
            </div>
            <div id="project" className="project_section">
              <MDBAnimation reveal type="zoomIn" duration="1000ms" delay="0.4s">
                <h1>Projects</h1>
              </MDBAnimation>
              <CarouselPage />
            </div>
            <div id="team" className="team_section">
              <MDBAnimation reveal type="zoomIn" duration="1000ms" delay="0.4s">
                <h1>Team Members</h1>
              </MDBAnimation>
              <Team />
            </div>
            <div id="contact" className="contact_section">
              <MDBAnimation reveal type="zoomIn" duration="1000ms" delay="0.4s">
                <h1>Contact Us</h1>
              </MDBAnimation>
              <Contact />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
